import {
  FlightCheckInStatusEnum,
  HotelCheckInStatusEnum,
} from 'common/constants/enum';
import useTranslation from 'next-translate/useTranslation';

interface CheckInStatusTagProps {
  status: HotelCheckInStatusEnum | FlightCheckInStatusEnum;
}
export default function CheckInStatusTag(props: CheckInStatusTagProps) {
  const { t } = useTranslation();
  return <>{props.status ? t(`enum:${props.status}`) : props.status}</>;
}
